import ErrorBoundary from './ErrorBoundary.container'

export default ErrorBoundary;
